<template>
    <div
        class="base-hero"
        :data-width="heroWidth"
    >
        <h1
            v-if="title"
            class="base-hero__title"
        >
            {{ title }}
        </h1>
        <p
            v-if="description"
            class="base-hero__description"
        >
            {{ description }}
        </p>
        <slot />
    </div>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: null
    },
    description: {
        type: String,
        default: null
    },
    heroWidth: {
        type: String,
        default: 'page',
        validator(value) {
            return ['page', 'content', 'bleed'].includes(value);
        }
    }
});
</script>

<style lang="less" src="./BaseHero.less" />
